import React from 'react';

import { LandingPageTeaser } from 'components/landing-page-teaser/LandingPageTeaser';

export const LandingPage: React.FC = () => {
    return <LandingPageTeaser />;
};
